// which client config do we include ?
import ClientConfig from "./clients/only-pets";

// any custom stuff to add here?
export default ClientConfig;
